import React, { Component } from 'react';
import { addCommasTicks, addCommasTooltip, unix_to_datestring } from '../../../ClientUtils';
import axios from 'axios';
import { standard_bar } from './standard_bar';
import { create_sets } from './GraphUtils';

const root_string = require('../../../config.json')['root_string'];
const assets = Object.keys(require('../../color_scheme.json'));

class V1_Daily_Volumes extends Component {

  constructor(props) {
    super(props);
    this.state = {
      labels: [],
      sets: []
    };
  }

  componentDidMount() {
    axios
      .get(root_string + '/api/data_api/V1_daily_volumes')
      .then(res => {
        let labels = [];
        const to_graph_assets = ["WETH", "ETH", "WBTC", "UNI", "Other"];
        let set_dictionary = create_sets(to_graph_assets, "Volumes");
        for (let datapoint of res.data["data"]) {
          labels.push(unix_to_datestring(datapoint["timestamp"]));
          let total_other = 0;
          for (let asset of assets) {
            let total_premium = parseInt(datapoint[asset + "_put"] + datapoint[asset + "_call"]);
            if (to_graph_assets.includes(asset)) {
              set_dictionary[asset]['data'].push(total_premium);
            } else {
              total_other += total_premium;
            }
          }
          set_dictionary["Other"]['data'].push(total_other);
        }
        this.setState({
          labels: labels,
          sets: Object.values(set_dictionary)
        })
      })
      .catch(err => {
        console.log('Error from V1 volumes API');
      });
  };


  render() {
    const options = {
      maintainAspectRatio: true,
      responsive: true,
      tooltips: {
        callbacks: {
          label: addCommasTooltip
        }
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Volume (USD)',
            fontSize: 14
          },
          stacked: true,
          ticks: {
            callback: addCommasTicks,
            maxTicksLimit: 8
          }
        }],
        xAxes: [{
          ticks: {
            autoSkip: true
          },
          scaleLabel: {
            display: true,
            labelString: '',
            ticks: {
              fontSize: 15
            },
            fontSize: 10
          },
          stacked: true
        }]
      }
    };
    return (
      standard_bar(this.state.sets, this.state.labels, options, 'Daily Volumes By Underlying')
    );
  }
}

export default V1_Daily_Volumes;
